export class SuitabilityAction {

    public static getQuestions: string = '[Suitability] get_questions';
    public static getQuestionsError: string = '[Suitability] get_questions_error';
    public static getQuestionsSuccess: string = '[Suitability] get_questions_success';

    public static getQuestion: string = '[Suitability] get_question';
    public static getQuestionError: string = '[Suitability] get_question_error';
    public static getQuestionSuccess: string = '[Suitability] get_question_success';

    public static getAnswers: string = '[Suitability] get_answers';
    public static getAnswersError: string = '[Suitability] get_answers_error';
    public static getAnswersSuccess: string = '[Suitability] get_answers_success';

    public static getProfile: string = '[Suitability] get_profile';
    public static getProfileError: string = '[Suitability] get_profile_error';
    public static getProfileSuccess: string = '[Suitability] get_profile_success';

    public static updateProfile: string = '[Suitability] update_profile';
    public static updateProfileError: string = '[Suitability] update_profile_error';
    public static updateProfileSuccess: string = '[Suitability] update_profile_success';

    public static getUserAnswers: string = '[Suitability] get_user_answers';
    public static getUserAnswersError: string = '[Suitability] get_user_answers_error';
    public static getUserAnswersSuccess: string = '[Suitability] get_user_answers_success';

    public static updateUserAnswers: string = '[Suitability] update_user_answers';
    public static updateUserAnswersError: string = '[Suitability] update_user_answers_error';
    public static updateUserAnswersSuccess: string = '[Suitability] update_user_answers_success';

    public static guidedSale: string = '[Suitability] guided_sale';
    public static guidedSaleError: string = '[Suitability] guided_sale_error';
    public static guidedSaleSuccess: string = '[Suitability] guided_sale_success';

    public static answerStep: string = '[Suitability] answer_step';
    public static answerStepError: string = '[Suitability] answer_step_error';
    public static answerStepSuccess: string = '[Suitability] answer_step_success';
    public static clearAnswerStepSuccess: string = '[Suitability] clear_answer_step_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
